<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<div class="main-container">
  <div class="sidebar" [ngClass]="collapse() ? 'sidebar-collapsed' : 'sidebar-expanded'" (mouseleave)="sideBarCollapsed()">
    <div class="header" (mouseenter)="onEnterHamburger($event)">
      <div *ngIf="!collapse()" class="brand-section">
        <img src="../../../assets/favicon.png" alt="iTrakSys" class="brand-icon">
        <h2 class="brand-title">iTrakSys</h2>
      </div>
      <div class="hamburger-block" (click)="onHamburger()" [ngClass]="collapse() ? 'hamburger-block-collapsed' : 'hamburger-block-expanded'">
        <img src="../../../assets/images/hamburger.svg" alt="" class="hamburger">
      </div>
    </div>
    
    <div class="navigation-block">
      <!-- nav list -->
      <div class="navigation-list">
        <!-- <a class="navigation-item" routerLink="/home/alerts-notify" routerLinkActive="active">
          <div class="item-block">
            <img src="../../../assets/images/sidebar/homeIcon.svg" class="navigation-item-icon" alt="" srcset="">
            <span *ngIf="!collapse()" class="navigation-item-label">Home</span>
          </div>
        </a> -->
        <div *ngIf="!collapse()" class="submenu" [ngClass]="showSubmenu1 ? 'submenu-expand' : 'submenu-collapse'">
          <a class="navigation-item" routerLink="/home/stocks/stores"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/store.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Product at Store</span>
            </div>
          </a>
          <a class="navigation-item" routerLink="/home/stocks/warehouse-products"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/warehouse.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Products at Warehouse</span>
            </div>
          </a>
          <a class="navigation-item" routerLink="/home/stocks/stock-upload"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/upload.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Stock Upload</span>
            </div>
          </a>
          <a class="navigation-item" routerLink="/home/stocks/cabinets"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/cabinet.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Cabinets</span>
            </div>
          </a>
          <a class="navigation-item" routerLink="/home/stocks/transfer-stock"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/transfer.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Transfer Stock</span>
            </div>
          </a>
          <a class="navigation-item" routerLink="/transit/summary"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/transit.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Transit Stock</span>
            </div>
          </a>
        </div>

        <a class="navigation-item" routerLink="/home/dashboard-v2" routerLinkActive="active"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/dashboard.svg" class="navigation-item-icon" alt="" srcset="">
            <span *ngIf="!collapse()" class="navigation-item-label">Dashboard</span>
          </div>
        </a>

        <a class="navigation-item" routerLink="/home/warehouse-dashboard-v2" routerLinkActive="active">
          <div class="item-block">
            <img src="../../../assets/images/sidebar/warehouse.svg" class="navigation-item-icon" alt="" srcset="">
            <span *ngIf="!collapse()" class="navigation-item-label">Warehouse</span>
          </div>
        </a>

        <!-- <a class="navigation-item" routerLink="/analytics" routerLinkActive="active"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/dashboard.svg" class="navigation-item-icon" alt="" srcset="">
            <span *ngIf="!collapse()" class="navigation-item-label">Analytics</span>
          </div>
        </a> -->

        <a class="navigation-item" routerLink="/home/search" routerLinkActive="active"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/search.svg" class="navigation-item-icon" alt="" srcset="">
            <span *ngIf="!collapse()" class="navigation-item-label">Search</span>
          </div>
        </a>
        <a class="navigation-item" routerLink="home/bulk-upload" routerLinkActive="active"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/upload.svg" class="navigation-item-icon" alt="" srcset="">
            <span *ngIf="!collapse()" class="navigation-item-label">Stock Upload</span>
          </div>
        </a>
        <a class="navigation-item" routerLink="/home/transit/summary" routerLinkActive="active"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/transit.svg" class="navigation-item-icon" alt="" srcset="">
            <span *ngIf="!collapse()" class="navigation-item-label">Transit Stock</span>
          </div>
        </a>
        <!-- stock -->
        <!-- <a class="navigation-item" (click)="showSubmenu(1)"
          [ngClass]="(route.url.includes('stocks') && collapse()) || (!showSubmenu1 && route.url.includes('stocks')) ? 'active' : ''"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/stock.svg" class="navigation-item-icon" alt="" srcset="">
            <span class="navigation-item-label" *ngIf="!collapse()">Stock</span>
          </div>
          <div *ngIf="!collapse()" [ngClass]="{'dropdrown-arrow-collapsed' : showSubmenu1}">
            <img src="../../../assets/images/sidebar/dropdown_arrow_down.svg" class="navigation-item-icon" alt="" srcset="">
          </div>
        </a> -->
        <!-- stock -->
  
        <!-- Master Data -->
        <div class="navigation-item" (click)="showSubmenu(2)" 
          [ngClass]="(route.url.includes('master') && collapse()) || (!showSubmenu2 && route.url.includes('master')) ? 'active' : ''"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/master_data.svg" class="navigation-item-icon" alt="" srcset="">
            <span class="navigation-item-label" *ngIf="!collapse()">Master Data</span>
          </div>
          <div *ngIf="!collapse()" [ngClass]="{'dropdrown-arrow-collapsed' : showSubmenu2}">
            <img src="../../../assets/images/sidebar/dropdown_arrow_down.svg" class="navigation-item-icon" alt="" srcset="">
          </div>
        </div>
        <div *ngIf="!collapse()" class="submenu" [ngClass]="showSubmenu2 ? 'submenu-expand' : 'submenu-collapse'">
          <a class="navigation-item" routerLink="home/masters/implants"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/implant.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Implant Types</span>
            </div>
          </a>
          <a class="navigation-item" routerLink="home/masters/location"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/location.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Locations</span>
            </div>
          </a>
        </div>
        <!-- Master Data -->
  
        <a class="navigation-item" routerLink="/home/sales" routerLinkActive="active"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/sales&report.svg" class="navigation-item-icon" alt="" srcset="">
            <span class="navigation-item-label" *ngIf="!collapse()">Sales & Report</span>
          </div>
        </a>
  
        <!-- Settings -->
        <div class="navigation-item" (click)="showSubmenu(3)"
          [ngClass]="(route.url.includes('user') && collapse()) || (!showSubmenu3 && route.url.includes('user')) ? 'active' : ''"
        >
          <div class="item-block">
            <img src="../../../assets/images/sidebar/setting.svg" class="navigation-item-icon" alt="" srcset="">
            <span class="navigation-item-label" *ngIf="!collapse()">Settings</span>
          </div>
          <div *ngIf="!collapse()" [ngClass]="{'dropdrown-arrow-collapsed' : showSubmenu3}">
            <img src="../../../assets/images/sidebar/dropdown_arrow_down.svg" class="navigation-item-icon" alt="" srcset="">
          </div>
        </div>
        <div *ngIf="!collapse()" class="submenu" [ngClass]="showSubmenu3 ? 'submenu-expand' : 'submenu-collapse'">
          <a class="navigation-item" routerLink="/users"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/users.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">Users</span>
            </div>
          </a>
          <a class="navigation-item" routerLink="/roles"
            routerLinkActive="active">
            <div class="item-block">
              <img src="../../../assets/images/sidebar/roles.svg" class="navigation-item-icon" alt="" srcset="">
              <span class="navigation-item-label intend">User roles</span>
            </div>
          </a>
        </div>
        <!-- Settings -->
      </div>
      <!-- nav list -->
    </div>

    <!-- copyright -->
    <div *ngIf="!collapse()" class="copyright-section">
      <p class="copyright">
        Copyright © 2025 KAMA Medicals
      </p>
    </div>
    <!-- copyright -->

  </div>
  <div class="right-content">
    <div class="header-block">
      <div class="header-content">
        <!-- Left Section - Page Title/Breadcrumb -->
        <div class="header-left">
          <div class="page-info">
          </div>
        </div>

        <!-- Right Section - Actions and User -->
        <div class="header-right">
          <!-- Action Buttons -->
          <div class="action-buttons">
            <!-- Alerts Dropdown -->
            <app-alerts-dropdown 
              [isOpen]="isAlertsDropdownOpen"
              (toggleDropdown)="toggleAlertsDropdown()">
            </app-alerts-dropdown>

            <!-- Notifications Dropdown -->
            <app-notifications-dropdown 
              [isOpen]="isNotificationsDropdownOpen"
              (toggleDropdown)="toggleNotificationsDropdown()">
            </app-notifications-dropdown>
          </div>

          <!-- User Profile -->
          <div class="user-wrapper">
            <div class="user-profile-card" [matMenuTriggerFor]="menu">
              <div class="user-avatar">
                <img src="../../../assets/images/users/user.png" alt="User Avatar">
                <div class="status-indicator"></div>
              </div>
              <div class="user-info">
                <h5 class="user-name">{{user?.username}}</h5>
                <p class="user-role">{{ roleName }}</p>
              </div>
              <div class="dropdown-icon">
                <!-- <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg> -->
              </div>
            </div>
            
            <mat-menu #menu="matMenu" class="user-menu">
              <!-- <mat-divider></mat-divider> -->
              <mat-nav-list class="menu-navigation">
                <a class="menu-item" mat-list-item (click)="navigateToProfilePage()">
                  <!-- <mat-icon class="menu-icon">person</mat-icon> -->
                  <span class="menu-label">Profile</span>
                </a>
                <a class="menu-item logout-item" mat-list-item (click)="logoutCurrent()">
                  <!-- <mat-icon class="menu-icon">logout</mat-icon> -->
                  <span class="menu-label">Logout</span>
                </a>
              </mat-nav-list>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="content-block">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
